<div class="container box" *ngIf="loaded; else loading">
  <mat-tab-group class="tab" #clientAutomation animationDuration="0ms">
    <mat-tab class="label" [disabled]="buttonClicked">
      <ng-template mat-tab-label>
        <span class="tab-style" [class.t-completed]="clientAutomation.selectedIndex > 0 || clientInfoForm.valid && client.clientLogo"
          [class.t-progress]="clientAutomation.selectedIndex >= 0 && (!clientInfoForm.valid || !client.clientLogo)"
          [class.t-focus]="clientAutomation.selectedIndex == 0 && clientInfoForm.valid && client.clientLogo">Client Info</span>
      </ng-template>
      <div class="options">
        <form #clientInfoForm="ngForm">
          <!-- <p>
            <mat-form-field appearance="outline" color="primary">
              <mat-label>Client Alias</mat-label>
              <input matInput [(ngModel)]="client.alias" type="text" name="alias" />
              <mat-error>*Client Alias is required</mat-error>
            </mat-form-field>
          </p> -->
          <!-- <p>
            <mat-form-field appearance="outline" color="primary">
              <mat-label>TOKEN</mat-label>
              <input matInput [(ngModel)]="client.srcToken" type="text" name="token" required />
              <mat-error>*Token is required</mat-error>
            </mat-form-field>
          </p> -->
          <!-- <p>
            <mat-form-field appearance="outline" color="primary">
              <mat-label>dstToken</mat-label>
              <input matInput [(ngModel)]="client.dstToken" type="text" name="dstToken" required />
              <mat-error>*dstToken is required</mat-error>
            </mat-form-field>
          </p>
          <p>
            <mat-form-field appearance="outline" color="primary">
              <mat-label>newAPIMySQLPwd</mat-label>
              <input matInput [(ngModel)]="client.newAPIMySQLPwd" type="text" name="newAPIMySQLPwd" required />
              <mat-error>*newAPIMySQLPwd is required</mat-error>
            </mat-form-field>
          </p>
          <p>
            <mat-form-field appearance="outline" color="primary">
              <mat-label>newZohoMySQLPwd</mat-label>
              <input matInput [(ngModel)]="client.newZohoMySQLPwd" type="text" name="newZohoMySQLPwd" required />
              <mat-error>*newZohoMySQLPwd is required</mat-error>
            </mat-form-field>
          </p> -->
          <p>
            <mat-form-field appearance="outline" color="primary">
              <mat-label>Client Name</mat-label>
              <input matInput [(ngModel)]="client.clientName" type="text" name="name" required />
              <mat-error>*Client Name is required</mat-error>
            </mat-form-field>
          </p>
          <p>
            <mat-form-field style="width: 212px;" appearance="outline" color="primary">
              <mat-label>Launch Date</mat-label>
              <input matInput [(ngModel)]="date" name="launchDate" (ngModelChange)="dateformat()" [matDatepicker]="picker" required />
              <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
              <mat-error>*Launch Date is required</mat-error>
            </mat-form-field>
          </p>
          <p>
            <mat-form-field appearance="outline" color="primary">
              <mat-label>Client Env Type</mat-label>
              <mat-select name="clientEnvType" placeholder="clientEnvType" [(ngModel)]="client.clientEnvType" required>
                <mat-option *ngFor="let item of options.clientEnvType" [value]="item.key">{{item.dKey}}</mat-option>
              </mat-select>
              <mat-error>*Client Env Type is required</mat-error>
            </mat-form-field>
          </p>
          <p>
            <mat-form-field appearance="outline" color="primary">
              <mat-label>Person Incharge</mat-label>
              <input matInput [(ngModel)]="client.personInCharge" type="text" name="incharge" required />
              <mat-error>*Person Incharge is required</mat-error>
            </mat-form-field>
          </p>
          <p>
            <button [ngClass]="{ 'indicator-logo': logoUploaded == true || logoError == true || logoUploaded == false}"
            class="button" color="primary" type="button" mat-raised-button (click)="fileInput.click()" required>
              <mat-icon>attachment</mat-icon>
              Logo*
            </button>
            <input hidden (change)="onFileSelected($event)" #fileInput name="logo" type="file"
              accept=".png, .PNG, .jpeg, .JPEG, .svg, .SVG, .webp, .WEBP" [(ngModel)]="image" #logo="ngModel"
              required />
            <span class="indicator-text">
              <span *ngIf="logoUploaded == true" style="color: #50C878;">Uploaded<span>&nbsp;</span><mat-icon>check_circle_outline</mat-icon><span>&nbsp;</span></span>
              <span *ngIf="logoUploaded == false" style="color: #ffa500;">Uploading<span>&nbsp;</span><span><mat-spinner class="spinner" diameter="15"></mat-spinner></span></span>
              <span *ngIf="logoError == true" class="retry" (click)="imageUrl()" >
                <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                <span>&nbsp;</span>Retry<span>&nbsp;</span><span>&nbsp;</span><mat-icon>refresh</mat-icon>
                <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
              </span>
            </span>
            <br>
            <span>
              <mat-hint style="width: 110px;"><b>{{ image?.name ? image?.name : "&nbsp;" }}
                  <i color="primary" class="remove" *ngIf="image?.name" mat-button (click)="image = null; logoUploaded = null; logoError = false; client.clientLogo = null">
                    <mat-icon>delete_forever</mat-icon>
                  </i>
                </b></mat-hint>
            </span>
          </p>
          <button [disabled]="!clientInfoForm.valid || !client.clientLogo" class="button next-fixed" color="primary" type="button"
            mat-raised-button (click)="clientAutomation.selectedIndex = 1">
            Next
          </button>
        </form>
      </div>
    </mat-tab>
    <mat-tab [disabled]="!clientInfoForm.valid || !client.clientLogo || buttonClicked">
      <ng-template mat-tab-label>
        <span class="tab-style" [class.t-completed]="clientAutomation.selectedIndex > 1 || emailInfoForm.valid"
          [class.t-focus]="clientAutomation.selectedIndex == 1 && emailInfoForm.valid && emailerr && emailBCCerr && emailCrewerr && emailCrewBCCerr && emailUpdateCrewerr && emailUpdateCrewBCCerr && emailLeaderboarderr && emailLeaderboardBCCerr"
          [class.t-progress]="clientAutomation.selectedIndex >= 1 && !emailInfoForm.valid || ( !emailerr || !emailBCCerr || !emailCrewerr || !emailCrewBCCerr || !emailUpdateCrewerr || !emailUpdateCrewBCCerr || !emailLeaderboarderr || !emailLeaderboardBCCerr )">Emails</span>
      </ng-template>
      <div class="options">
        <form #emailInfoForm="ngForm">
          <p class="bcc" style="margin-top: 50px;">
            <mat-form-field appearance="outline" color="primary">
              <mat-label>Email</mat-label>
              <input matInput [(ngModel)]="client.email" type="email" name="email" #email="ngModel"
                (ngModelChange)="errorsEmail( email, 0)" required />
              <mat-error>*Email is required</mat-error>
              <mat-hint class="error" *ngIf="!emailerr">*Invalid email format</mat-hint>
            </mat-form-field>
            <mat-form-field appearance="outline" color="primary">
              <mat-label>BCC</mat-label>
              <input matInput [(ngModel)]="client.emailBCC" type="email" name="emailBCC" #emailBCC="ngModel"
                (ngModelChange)="errorsEmail( emailBCC, 1)" />
              <!-- <mat-error>*BCC is required</mat-error> -->
              <mat-hint class="error" *ngIf="!emailBCCerr">*Invalid email format</mat-hint>
            </mat-form-field>
          </p>
          <p class="bcc">
            <mat-form-field appearance="outline" color="primary">
              <mat-label>Crew Email</mat-label>
              <input matInput [(ngModel)]="client.emailCrew" type="email" name="emailCrew" #emailCrew="ngModel"
                (ngModelChange)="errorsEmail( emailCrew, 2)" required />
              <mat-error>*Crew Email is required</mat-error>
              <mat-hint class="error" *ngIf="!emailCrewerr">*Invalid email format</mat-hint>
            </mat-form-field>
            <mat-form-field appearance="outline" color="primary">
              <mat-label>BCC</mat-label>
              <input matInput [(ngModel)]="client.emailCrewBCC" type="email" name="emailCrewBCC" #emailCrewBCC="ngModel"
                (ngModelChange)="errorsEmail( emailCrewBCC, 3)" />
              <!-- <mat-error>*BCC is required</mat-error> -->
              <mat-hint class="error" *ngIf="!emailCrewBCCerr">*Invalid email format</mat-hint>
            </mat-form-field>
          </p>
          <p class="bcc">
            <mat-form-field appearance="outline" color="primary">
              <mat-label>Crew Update Email</mat-label>
              <input matInput [(ngModel)]="client.emailUpdateCrew" type="email" name="emailUpdateCrew"
                #emailUpdateCrew="ngModel" (ngModelChange)="errorsEmail( emailUpdateCrew, 4)" required />
              <mat-error>*Crew Update Email is required</mat-error>
              <mat-hint class="error" *ngIf="!emailUpdateCrewerr">*Invalid email format</mat-hint>
            </mat-form-field>
            <mat-form-field appearance="outline" color="primary">
              <mat-label>BCC</mat-label>
              <input matInput [(ngModel)]="client.emailUpdateCrewBCC" type="email" name="emailUpdateCrewBCC"
                #emailUpdateCrewBCC="ngModel" (ngModelChange)="errorsEmail( emailUpdateCrewBCC, 5)" />
              <!-- <mat-error>*BCC is required</mat-error> -->
              <mat-hint class="error" *ngIf="!emailUpdateCrewBCCerr">*Invalid email format</mat-hint>
            </mat-form-field>
          </p>
          <p class="bcc">
            <mat-form-field appearance="outline" color="primary">
              <mat-label>Leaderboard Email</mat-label>
              <input matInput [(ngModel)]="client.emailLeaderboard" type="email" name="emailLeaderboard"
                #emailLeaderboard="ngModel" (ngModelChange)="errorsEmail( emailLeaderboard, 6)" required />
              <mat-error>*Leaderboard Email is required</mat-error>
              <mat-hint class="error" *ngIf="!emailLeaderboarderr">*Invalid email format</mat-hint>
            </mat-form-field>
            <mat-form-field appearance="outline" color="primary">
              <mat-label>BCC</mat-label>
              <input matInput [(ngModel)]="client.emailLeaderboardBCC" type="email" name="emailLeaderboardBCC"
                #emailLeaderboardBCC="ngModel" (ngModelChange)="errorsEmail( emailLeaderboardBCC, 7)" />
              <!-- <mat-error>*BCC is required</mat-error> -->
              <mat-hint class="error" *ngIf="!emailLeaderboardBCCerr">*Invalid email format</mat-hint>
            </mat-form-field>
          </p>
          <button class="button back-fixed" color="primary" type="button" mat-raised-button
            (click)="clientAutomation.selectedIndex = 0" required>
            Back
          </button>
          <button
            [disabled]="!emailInfoForm.valid || ( !emailerr || !emailBCCerr || !emailCrewerr || !emailCrewBCCerr || !emailUpdateCrewerr || !emailUpdateCrewBCCerr || !emailLeaderboarderr || !emailLeaderboardBCCerr )"
            class="button next-fixed" color="primary" type="button" mat-raised-button
            (click)="clientAutomation.selectedIndex = 2" required>
            Next
          </button>
        </form>
      </div>
    </mat-tab>
    <mat-tab
      [disabled]="!clientInfoForm.valid || !client.clientLogo || (!emailInfoForm.valid || ( !emailerr || !emailBCCerr || !emailCrewerr || !emailCrewBCCerr || !emailUpdateCrewerr || !emailUpdateCrewBCCerr || !emailLeaderboarderr || !emailLeaderboardBCCerr )) || buttonClicked">
      <ng-template mat-tab-label>
        <span class="tab-style" [class.t-completed]="clientAutomation.selectedIndex > 2 || hostInfoForm.valid && client.mgmntDBSource"
          [class.t-progress]="clientAutomation.selectedIndex >= 2 && (!hostInfoForm.valid || !client.mgmntDBSource)"
          [class.t-focus]="clientAutomation.selectedIndex == 2 && hostInfoForm.valid && client.mgmntDBSource">Deployment</span>
      </ng-template>
      <div class="options">
        <form #hostInfoForm="ngForm">
          <div class="column">
            <p>
              <mat-form-field appearance="outline" color="primary">
                <mat-label>nginx App Port</mat-label>
                <input matInput [(ngModel)]="client.nginxAppPort" type="number" name="nginxAppPort"
                  #nginxAppPort="ngModel" pattern="[0-9]+" required min="1" />
                <mat-error *ngIf="nginxAppPort.invalid && (nginxAppPort.dirty || nginxAppPort.touched)">
                  <span *ngIf="nginxAppPort.errors.required">*nginx App Port is required</span>
                  <span *ngIf="nginxAppPort.errors.min">Port must be greater than 0.</span>
                  <span *ngIf="nginxAppPort.errors.pattern && !nginxAppPort.errors.min">Port number shouldn't be a decimal</span>
                </mat-error>
              </mat-form-field>
            </p>
            <p>
              <mat-form-field appearance="outline" color="primary">
                <mat-label>nginx Web Port</mat-label>
                <input matInput [(ngModel)]="client.nginxWebPort" type="number" name="nginxWebPort"
                  #nginxWebPort="ngModel" pattern="[0-9]+" required min="1" />
                <mat-error *ngIf="nginxWebPort.invalid && (nginxWebPort.dirty || nginxWebPort.touched)">
                  <span *ngIf="nginxWebPort.errors.required">*nginx Web Port is required</span>
                  <span *ngIf="nginxWebPort.errors.min">Port must be greater than 0.</span>
                  <span *ngIf="nginxWebPort.errors.pattern && !nginxWebPort.errors.min">Port number shouldn't be a decimal</span>
                </mat-error>
              </mat-form-field>
            </p>
            <p>
              <mat-form-field appearance="outline" color="primary">
                <mat-label>Node Port</mat-label>
                <input matInput [(ngModel)]="client.nodeAPIPort" type="number" name="node" #node="ngModel"
                  pattern="[0-9]+" required min="1" />
                <mat-error *ngIf="node.invalid && (node.dirty || node.touched)">
                  <span *ngIf="node.errors.required">*Node Port is required</span>
                  <span *ngIf="node.errors.min">Port must be greater than 0.</span>
                  <span *ngIf="node.errors.pattern && !node.errors.min">Port number shouldn't be a decimal</span>
                </mat-error>
              </mat-form-field>
            </p>
            <p>
              <mat-form-field appearance="outline" color="primary">
                <mat-label>CMS Port</mat-label>
                <input matInput [(ngModel)]="client.cmsAPIPort" type="number" name="cms" #cms="ngModel" pattern="[0-9]+"
                  required min="1" />
                <mat-error *ngIf="cms.invalid && (cms.dirty || cms.touched)">
                  <span *ngIf="cms.errors.required">*CMS Port is required</span>
                  <span *ngIf="cms.errors.min">Port must be greater than 0.</span>
                  <span *ngIf="cms.errors.pattern && !cms.errors.min">Port number shouldn't be a decimal</span>
                </mat-error>
              </mat-form-field>
            </p>
            <p>
              <mat-form-field appearance="outline" color="primary">
                <mat-label>Insight Port</mat-label>
                <input matInput [(ngModel)]="client.insightAPIPort" type="number" name="insight" pattern="[0-9]+"
                  #insight="ngModel" required min="1" />
                <mat-error *ngIf="insight.invalid && (insight.dirty || insight.touched)">
                  <span *ngIf="insight.errors.required">*Insight Port is required</span>
                  <span *ngIf="insight.errors.min">Port must be greater than 0.</span>
                  <span *ngIf="insight.errors.pattern && !insight.errors.min">Port number shouldn't be a decimal</span>
                </mat-error>
              </mat-form-field>
            </p>
          </div>
          <div class="column">
            <p>
              <mat-form-field appearance="outline" color="primary">
                <mat-label>node API Branch</mat-label>
                <input matInput [(ngModel)]="client.nodeAPIBranch" type="text" name="nodeAPIBranch" required />
                <mat-error>*node API Branch is required</mat-error>
              </mat-form-field>
            </p>
            <p>
              <mat-form-field appearance="outline" color="primary">
                <mat-label>cms API Branch</mat-label>
                <input matInput [(ngModel)]="client.cmsAPIBranch" type="text" name="cmsAPIBranch" required />
                <mat-error>*cms API Branch is required</mat-error>
              </mat-form-field>
            </p>
            <p>
              <mat-form-field appearance="outline" color="primary">
                <mat-label>insight API Branch</mat-label>
                <input matInput [(ngModel)]="client.insightAPIBranch" type="text" name="insightAPIBranch" required />
                <mat-error>*insight API Branch is required</mat-error>
              </mat-form-field>
            </p>
            <p>
              <mat-form-field appearance="outline" color="primary">
                <mat-label>labs API Branch</mat-label>
                <input matInput [(ngModel)]="client.labsAPIBranch" type="text" name="labsAPIBranch" required />
                <mat-error>*labs API Branch is required</mat-error>
              </mat-form-field>
            </p>
            <p>
              <mat-form-field appearance="outline" color="primary">
                <mat-label>ansible Branch</mat-label>
                <input matInput [(ngModel)]="client.ansibleBranch" type="text" name="ansibleBranch" required />
                <mat-error>*ansible Branch is required</mat-error>
              </mat-form-field>
            </p>
          </div>
          <div class="column">
            <p>
              <mat-form-field appearance="outline" color="primary">
                <mat-label>liquibase RepoBranch</mat-label>
                <input matInput [(ngModel)]="client.liquibaseRepoBranch" type="text" name="liquibaseRepoBranch"
                  required />
                <mat-error>*liquibase RepoBranch is required</mat-error>
              </mat-form-field>
            </p>
            <p>
              <mat-form-field appearance="outline" color="primary">
                <mat-label>admin AWS AccessKeyID</mat-label>
                <input matInput [(ngModel)]="client.adminAWSAccessKeyID" type="text" name="adminAWSAccessKeyID"
                  required />
                <mat-error>*admin AWS AccessKeyID is required</mat-error>
              </mat-form-field>
            </p>
            <p>
              <mat-form-field appearance="outline" color="primary">
                <mat-label>admin AWS SecretAccessKey</mat-label>
                <input matInput [(ngModel)]="client.adminAWSSecretAccessKey" type="text" name="adminAWSSecretAccessKey"
                  required />
                <mat-error>*admin AWS SecretAccessKey is required</mat-error>
              </mat-form-field>
            </p>
            <p>
              <mat-form-field appearance="outline" color="primary">
                <mat-label>admin AWS SessionToken</mat-label>
                <input matInput [(ngModel)]="client.adminAWSSessionToken" type="text" name="adminAWSSessionToken"
                  required />
                <mat-error>*admin AWS SessionToken is required</mat-error>
              </mat-form-field>
            </p>
            <p>
              <button [ngClass]="{ 'indicator-zip': zipUploaded == true || zipError == true || zipUploaded == false}"
              class="button" color="primary" type="button" mat-raised-button (click)="fileInput1.click()"
                required>
                <mat-icon>attachment</mat-icon>
                Mgmnt DB Source*
              </button>
              <input hidden (change)="onFileSelected1($event)" #fileInput1 name="mgmntDBSource" type="file"
                accept=".zip, .ZIP" [(ngModel)]="zip" #mgmntDBSource="ngModel" required />
              <br>
              <span>
                <mat-hint style="width: 110px;"><b>{{ zip?.name ? zip?.name : "&nbsp;" }}
                    <i color="primary" class="remove" *ngIf="zip?.name" mat-button (click)="zip = null; zipUploaded = null; zipError = false; client.mgmntDBSource = null">
                      <mat-icon>delete_forever</mat-icon>
                    </i>
                  </b></mat-hint>
              </span>
              <span class="indicator-text-zip">
                <span *ngIf="zipUploaded == true" style="color: #50C878;">Uploaded<span>&nbsp;</span><mat-icon>check_circle_outline</mat-icon><span>&nbsp;</span></span>
                <span *ngIf="zipUploaded == false" style="color: #ffa500;">Uploading<span>&nbsp;</span><span class="spinner"><mat-spinner class="spinner" diameter="15"></mat-spinner></span></span>
                <span *ngIf="zipError == true" class="retry" (click)="zipUrl()" >
                  <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                  <span>&nbsp;</span>Retry<span>&nbsp;</span><span>&nbsp;</span><mat-icon>refresh</mat-icon>
                  <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                </span>
              </span>
            </p>
          </div>
          <div class="column">
            <p>
              <mat-form-field appearance="outline" color="primary">
                <mat-label>dst Server</mat-label>
                <mat-select name="dstServer" placeholder="dstServer" [(ngModel)]="client.dstServer" required>
                  <mat-option *ngFor="let item of options.dstServer" [value]="item.key">{{item.dKey}}</mat-option>
                </mat-select>
                <mat-error>*dst Server is required</mat-error>
              </mat-form-field>
            </p>
            <p>
              <mat-form-field appearance="outline" color="primary">
                <mat-label>private Prod DBHost</mat-label>
                <input matInput [(ngModel)]="client.privateProdDBHost" type="text" name="privateProdDBHost" required />
                <mat-error>*privateProdDBHost is required</mat-error>
              </mat-form-field>
            </p>
          </div>
          <button class="button back-fixed" color="primary" type="button" mat-raised-button
            (click)="clientAutomation.selectedIndex = 1" required>
            Back
          </button>
          <button [disabled]="!hostInfoForm.valid || !client.mgmntDBSource" class="button next-fixed" color="primary" type="button"
            mat-raised-button (click)="clientAutomation.selectedIndex = 3" required>
            Next
          </button>
        </form>
      </div>
    </mat-tab>
    <mat-tab
      [disabled]="!clientInfoForm.valid || !client.clientLogo || (!emailInfoForm.valid || ( !emailerr || !emailBCCerr || !emailCrewerr || !emailCrewBCCerr || !emailUpdateCrewerr || !emailUpdateCrewBCCerr || !emailLeaderboarderr || !emailLeaderboardBCCerr )) || !hostInfoForm.valid || !client.mgmntDBSource || buttonClicked">
      <ng-template mat-tab-label>
        <span class="tab-style" [class.t-completed]="clientAutomation.selectedIndex > 3 || othersInfoForm.valid"
          [class.t-progress]="clientAutomation.selectedIndex == 3 && !othersInfoForm.valid"
          [class.t-focus]="clientAutomation.selectedIndex == 3 && othersInfoForm.valid">App</span>
      </ng-template>
      <div class="options">
        <form #othersInfoForm="ngForm">
          <p class="bcc">
            <mat-form-field appearance="outline" color="primary">
              <mat-label>Game Stages</mat-label>
              <input matInput [(ngModel)]="client.gameStages" type="number" name="gameStages" #gameStages="ngModel" pattern="[0-9]+"
                required min="1" />
              <mat-error *ngIf="gameStages.invalid && (gameStages.dirty || gameStages.touched)">
                <span *ngIf="gameStages.errors.required">*Game Stages is required</span>
                <span *ngIf="gameStages.errors.min">Stages must be greater than 0.</span>
                <span *ngIf="gameStages.errors.pattern && !gameStages.errors.min">Stages shouldn't be a decimal</span>
              </mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" color="primary">
              <mat-label>ML Status</mat-label>
              <mat-select name="ml" placeholder="ML Status" [(ngModel)]="client.mlStatus" required>
                <mat-option *ngFor="let item of options.mlStatus" [value]="item.key">{{item.dKey}}</mat-option>
              </mat-select>
              <mat-error>*ML Status is required</mat-error>
            </mat-form-field>
          </p>
          <p class="bcc">
            <mat-form-field appearance="outline" color="primary">
              <mat-label>App Type</mat-label>
              <mat-select name="app" placeholder="App Type" [(ngModel)]="client.appType" (ngModelChange)="appVersions()" required>
                <mat-option *ngFor="let item of options.appType" [value]="item.key">{{item.dKey}}</mat-option>
              </mat-select>
              <mat-error>*App Type is required</mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" color="primary">
              <mat-label>Master key PWD Type</mat-label>
              <mat-select name="masterPwdType" placeholder="Master key PWD" [(ngModel)]="client.masterPwdType" required>
                <mat-option *ngFor="let item of options.masterPwdType" [value]="item.key">{{item.dKey}}</mat-option>
              </mat-select>
              <mat-error>*Master key Pwd Type is required</mat-error>
            </mat-form-field>
          </p>
          <p class="bcc">
            <mat-form-field appearance="outline" color="primary">
              <mat-label>Android Verison</mat-label>
              <input matInput [(ngModel)]="client.androidVersion" type="text" name="android" required />
              <mat-error>*Android Verison is required</mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" color="primary">
              <mat-label>IOS Version</mat-label>
              <input matInput [(ngModel)]="client.iOSVersion" type="text" name="ios" required />
              <mat-error>*IOS Version is required</mat-error>
            </mat-form-field>
          </p>
          <!-- <p>  commented for future as per Backend request
            <mat-form-field appearance="outline" color="primary">
              <mat-label>Database Password</mat-label>
              <input matInput [(ngModel)]="client.databasepwd" type="text" name="database" required />
              <mat-error>*Database Password is required</mat-error>
            </mat-form-field>
          </p> -->
          <button class="button back-fixed" color="primary" type="button" mat-raised-button
            (click)="clientAutomation.selectedIndex = 2" required>
            Back
          </button>
          <button
            [disabled]="!othersInfoForm.valid || !clientInfoForm.valid || (!emailInfoForm.valid || ( !emailerr || !emailBCCerr || !emailCrewerr || !emailCrewBCCerr || !emailUpdateCrewerr || !emailUpdateCrewBCCerr || !emailLeaderboarderr || !emailLeaderboardBCCerr )) || !hostInfoForm.valid"
            class="button next-fixed" color="primary" type="button" mat-raised-button
            (click)="clientAutomation.selectedIndex = 4" required>
            Preview
          </button>
        </form>
      </div>
    </mat-tab>
    <mat-tab
      [disabled]="!clientInfoForm.valid || (!emailInfoForm.valid || ( !emailerr || !emailBCCerr || !emailCrewerr || !emailCrewBCCerr || !emailUpdateCrewerr || !emailUpdateCrewBCCerr || !emailLeaderboarderr || !emailLeaderboardBCCerr )) || !hostInfoForm.valid || !othersInfoForm.valid || !client.mgmntDBSource || !client.clientLogo">
      <ng-template mat-tab-label>
        <span class="tab-style"
          [class.t-completed]="clientInfoForm.valid && client.clientLogo && (emailInfoForm.valid && ( emailerr && emailBCCerr && emailCrewerr && emailCrewBCCerr && emailUpdateCrewerr && emailUpdateCrewBCCerr && emailLeaderboarderr && emailLeaderboardBCCerr )) && hostInfoForm.valid && client.mgmntDBSource && othersInfoForm.valid"
          [class.t-focus]="clientAutomation.selectedIndex == 4">Preview</span>
      </ng-template>
      <div class="options">
        <div class="column">
          <!-- <p *ngIf="client.srcToken">
            <mat-form-field appearance="outline" color="primary">
              <mat-label>TOKEN</mat-label>
              <input matInput [(ngModel)]="client.srcToken" type="text" name="token" required readonly />
            </mat-form-field>
          </p> -->
          <p *ngIf="client.clientName">
            <mat-form-field appearance="outline" color="primary">
              <mat-label>Client Name</mat-label>
              <input matInput [(ngModel)]="client.clientName" type="text" name="name" required readonly />
            </mat-form-field>
          </p>
          <p *ngIf="client.clientLogo" style="margin-bottom: 35px;">
            <span>Logo: </span><a href="{{client.clientLogo}}">{{logoName}}</a>
            <img height="auto" width="200px" src="{{client.clientLogo}}" alt="Logo">
          </p>
          <p *ngIf="client.nginxAppPort">
            <mat-form-field appearance="outline" color="primary">
              <mat-label>nginx App Port</mat-label>
              <input matInput [(ngModel)]="client.nginxAppPort" type="number" name="nginxAppPort"
                #nginxAppPort="ngModel" pattern="[0-9]+" required min="1" readonly />
            </mat-form-field>
          </p>
          <p *ngIf="client.nginxWebPort">
            <mat-form-field appearance="outline" color="primary">
              <mat-label>nginx Web Port</mat-label>
              <input matInput [(ngModel)]="client.nginxWebPort" type="number" name="nginxWebPort"
                #nginxWebPort="ngModel" pattern="[0-9]+" required min="1" readonly />
            </mat-form-field>
          </p>
          <p *ngIf="client.nodeAPIPort">
            <mat-form-field appearance="outline" color="primary">
              <mat-label>Node Port</mat-label>
              <input matInput [(ngModel)]="client.nodeAPIPort" type="number" name="node" #node="ngModel" required
                min="1" readonly />
            </mat-form-field>
          </p>
          <p *ngIf="client.cmsAPIPort">
            <mat-form-field appearance="outline" color="primary">
              <mat-label>CMS Port</mat-label>
              <input matInput [(ngModel)]="client.cmsAPIPort" type="number" name="cms" #cms="ngModel" required min="1"
                readonly />
            </mat-form-field>
          </p>
          <p *ngIf="client.insightAPIPort">
            <mat-form-field appearance="outline" color="primary">
              <mat-label>Insight Port</mat-label>
              <input matInput [(ngModel)]="client.insightAPIPort" type="number" name="insight" #insight="ngModel"
                required min="1" readonly />
            </mat-form-field>
          </p>
          <div style="margin-bottom: 35px;">
            <div *ngIf="client.email">
              <p><strong>Email :</strong></p>
              <div *ngFor="let item of client.email.split(',')">
                <p>{{item}}</p>
              </div>
            </div>
            <div *ngIf="client.emailBCC">
              <p><strong>BCC :</strong></p>
              <div *ngFor="let item of client.emailBCC.split(',')">
                <p>{{item}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="column">
          <p *ngIf="client.launchDate">
            <mat-form-field appearance="outline" color="primary" style="pointer-events: none; width: 212px;">
              <mat-label>Launch Date</mat-label>
              <input matInput [(ngModel)]="date" name="launchDate" [matDatepicker]="picker" required
                readonly />
              <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </p>
          <p *ngIf="client.appType">
            <mat-form-field appearance="outline" color="primary" style="pointer-events: none;">
              <mat-label>App Type</mat-label>
              <mat-select name="app" placeholder="App Type" [(ngModel)]="client.appType" required>
                <mat-option *ngFor="let item of options.appType" [value]="item.key">{{item.dKey}}</mat-option>
              </mat-select>
            </mat-form-field>
          </p>
          <p *ngIf="client.nodeAPIBranch">
            <mat-form-field appearance="outline" color="primary">
              <mat-label>node API Branch</mat-label>
              <input matInput [(ngModel)]="client.nodeAPIBranch" type="text" name="nodeAPIBranch" required readonly />
            </mat-form-field>
          </p>
          <p *ngIf="client.cmsAPIBranch">
            <mat-form-field appearance="outline" color="primary">
              <mat-label>cms API Branch</mat-label>
              <input matInput [(ngModel)]="client.cmsAPIBranch" type="text" name="cmsAPIBranch" required readonly />
            </mat-form-field>
          </p>
          <p *ngIf="client.insightAPIBranch">
            <mat-form-field appearance="outline" color="primary">
              <mat-label>insight API Branch</mat-label>
              <input matInput [(ngModel)]="client.insightAPIBranch" type="text" name="insightAPIBranch" required
                readonly />
            </mat-form-field>
          </p>
          <p *ngIf="client.labsAPIBranch">
            <mat-form-field appearance="outline" color="primary">
              <mat-label>labs API Branch</mat-label>
              <input matInput [(ngModel)]="client.labsAPIBranch" type="text" name="labsAPIBranch" required readonly />
            </mat-form-field>
          </p>
          <p *ngIf="client.ansibleBranch">
            <mat-form-field appearance="outline" color="primary">
              <mat-label>ansible Branch</mat-label>
              <input matInput [(ngModel)]="client.ansibleBranch" type="text" name="ansibleBranch" required readonly />
            </mat-form-field>
          </p>
          <p *ngIf="client.liquibaseRepoBranch">
            <mat-form-field appearance="outline" color="primary">
              <mat-label>liquibase RepoBranch</mat-label>
              <input matInput [(ngModel)]="client.liquibaseRepoBranch" type="text" name="liquibaseRepoBranch" required
                readonly />
            </mat-form-field>
          </p>
          <div style="margin-bottom: 35px;">
            <div *ngIf="client.emailCrew">
              <p><strong>Crew Email :</strong></p>
              <div *ngFor="let item of client.emailCrew.split(',')">
                <p>{{item}}</p>
              </div>
            </div>
            <div *ngIf="client.emailCrewBCC">
              <p><strong>BCC :</strong></p>
              <div *ngFor="let item of client.emailCrewBCC.split(',')">
                <p>{{item}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="column">
          <p *ngIf="client.clientEnvType">
            <mat-form-field appearance="outline" color="primary" style="pointer-events: none">
              <mat-label>Client Env Type</mat-label>
              <mat-select name="clientEnvType" placeholder="clientEnvType" [(ngModel)]="client.clientEnvType" required>
                <mat-option *ngFor="let item of options.clientEnvType" [value]="item.key">{{item.dKey}}</mat-option>
              </mat-select>
            </mat-form-field>
          </p>
          <p *ngIf="client.androidVersion">
            <mat-form-field appearance="outline" color="primary">
              <mat-label>Android Verison</mat-label>
              <input matInput [(ngModel)]="client.androidVersion" type="text" name="android" required readonly/>
            </mat-form-field>
          </p>
          <p *ngIf="client.adminAWSAccessKeyID">
            <mat-form-field appearance="outline" color="primary">
              <mat-label>admin AWS AccessKeyID</mat-label>
              <input matInput [(ngModel)]="client.adminAWSAccessKeyID" type="text" name="adminAWSAccessKeyID" required
                readonly />
            </mat-form-field>
          </p>
          <p *ngIf="client.adminAWSSecretAccessKey">
            <mat-form-field appearance="outline" color="primary">
              <mat-label>admin AWS SecretAccessKey</mat-label>
              <input matInput [(ngModel)]="client.adminAWSSecretAccessKey" type="text" name="adminAWSSecretAccessKey"
                required readonly />
            </mat-form-field>
          </p>
          <p *ngIf="client.adminAWSSessionToken">
            <mat-form-field appearance="outline" color="primary">
              <mat-label>admin AWS SessionToken</mat-label>
              <input matInput [(ngModel)]="client.adminAWSSessionToken" type="text" name="adminAWSSessionToken" required
                readonly />
            </mat-form-field>
          </p>
          <p *ngIf="client.masterPwdType">
            <mat-form-field appearance="outline" color="primary" style="pointer-events: none;">
              <mat-label>Master key PWD Type</mat-label>
              <mat-select name="ml" placeholder="Master key PWD" [(ngModel)]="client.masterPwdType" required>
                <mat-option *ngFor="let item of options.masterPwdType" [value]="item.key">{{item.dKey}}</mat-option>
              </mat-select>
            </mat-form-field>
          </p>
          <div style="margin-bottom: 35px;">
            <div *ngIf="client.emailUpdateCrew">
              <p><strong>Crew Update Email :</strong></p>
              <div *ngFor="let item of client.emailUpdateCrew.split(',')">
                <p>{{item}}</p>
              </div>
            </div>
            <div *ngIf="client.emailUpdateCrewBCC">
              <p><strong>BCC :</strong></p>
              <div *ngFor="let item of client.emailUpdateCrewBCC.split(',')">
                <p>{{item}}</p>
              </div>
            </div>
          </div>
          <!-- <p *ngIf="client.dstToken">
            <mat-form-field appearance="outline" color="primary">
              <mat-label>dstToken</mat-label>
              <input matInput [(ngModel)]="client.dstToken" type="text" name="dstToken" required readonly />
            </mat-form-field>
          </p>
          <p *ngIf="client.newAPIMySQLPwd">
            <mat-form-field appearance="outline" color="primary">
              <mat-label>newAPIMySQLPwd</mat-label>
              <input matInput [(ngModel)]="client.newAPIMySQLPwd" type="text" name="newAPIMySQLPwd" required readonly />
            </mat-form-field>
          </p>
          <p *ngIf="client.newZohoMySQLPwd">
            <mat-form-field appearance="outline" color="primary">
              <mat-label>newZohoMySQLPwd</mat-label>
              <input matInput [(ngModel)]="client.newZohoMySQLPwd" type="text" name="newZohoMySQLPwd" required
                readonly />
            </mat-form-field>
          </p> -->
        </div>
        <div class="column">
          <p *ngIf="client.personInCharge">
            <mat-form-field appearance="outline" color="primary">
              <mat-label>Person Incharge</mat-label>
              <input matInput [(ngModel)]="client.personInCharge" type="text" name="incharge" required readonly />
            </mat-form-field>
          </p>
          <p *ngIf="client.iOSVersion">
            <mat-form-field appearance="outline" color="primary">
              <mat-label>IOS Version</mat-label>
              <input matInput [(ngModel)]="client.iOSVersion" type="text" name="ios" required readonly/>
            </mat-form-field>
          </p>
          <p *ngIf="client.dstServer">
            <mat-form-field appearance="outline" color="primary" style="pointer-events: none">
              <mat-label>dst Server</mat-label>
              <mat-select name="dstServer" placeholder="dstServer" [(ngModel)]="client.dstServer" required>
                <mat-option *ngFor="let item of options.dstServer" [value]="item.key">{{item.dKey}}</mat-option>
              </mat-select>
            </mat-form-field>
          </p>
          <p *ngIf="client.privateProdDBHost">
            <mat-form-field appearance="outline" color="primary">
              <mat-label>private Prod DBHost</mat-label>
              <input matInput [(ngModel)]="client.privateProdDBHost" type="text" name="privateProdDBHost" required
                readonly />
            </mat-form-field>
          </p>
          <p *ngIf="client.gameStages">
            <mat-form-field appearance="outline" color="primary">
              <mat-label>Game Stages</mat-label>
              <input matInput [(ngModel)]="client.gameStages" type="number" name="gameStages" #gameStages="ngModel" required min="1"
                readonly />
            </mat-form-field>
          </p>
          <p *ngIf="client.mlStatus">
            <mat-form-field appearance="outline" color="primary" style="pointer-events: none">
              <mat-label>ML Status</mat-label>
              <mat-select name="ml" placeholder="ML Status" [(ngModel)]="client.mlStatus" required>
                <mat-option *ngFor="let item of options.mlStatus" [value]="item.key">{{item.dKey}}</mat-option>
              </mat-select>
            </mat-form-field>
          </p>
          <p *ngIf="client.mgmntDBSource" style="margin-bottom: 35px;">
            <span>Mgmnt DB Source : </span>
            <a height="auto" href="{{client.mgmntDBSource}}">{{mgmntDBSourceName}}</a>
          </p>
          <div style="margin-bottom: 35px;">
            <div *ngIf="client.emailLeaderboard">
              <p><strong>LeaderBoard Email :</strong></p>
              <div *ngFor="let item of client.emailLeaderboard.split(',')">
                <p>{{item}}</p>
              </div>
            </div>
            <div *ngIf="client.emailLeaderboardBCC">
              <p><strong>BCC :</strong></p>
              <div *ngFor="let item of client.emailLeaderboardBCC.split(',')">
                <p>{{item}}</p>
              </div>
            </div>
          </div>
          <!-- <p *ngIf="client.alias">
            <mat-form-field appearance="outline" color="primary">
              <mat-label>Client Alias</mat-label>
              <input matInput [(ngModel)]="client.alias" type="text" name="alias" readonly />
            </mat-form-field>
          </p> -->
        </div>
        <button class="button back-fixed" color="primary" type="button" mat-raised-button
          *ngIf="viewLog" (click)="viewLogs()">
            View Logs
          </button>
        <button
          [disabled]="!othersInfoForm.valid || !clientInfoForm.valid || (!emailInfoForm.valid || ( !emailerr || !emailBCCerr || !emailCrewerr || !emailCrewBCCerr || !emailUpdateCrewerr || !emailUpdateCrewBCCerr || !emailLeaderboarderr || !emailLeaderboardBCCerr )) || !hostInfoForm.valid || buttonClicked"
          class="button next-fixed" color="primary" type="button" mat-raised-button (click)="onSubmit()">
          {{ buttonClicked ? "Deploying" : "Submit" }}
          <span>
            <mat-icon *ngIf="buttonClicked">
                <mat-spinner diameter="25"></mat-spinner>
            </mat-icon>
          </span>
        </button>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
<ng-template #loading>
  <div class="center loading">
    <span class="d">.</span><span class="d d-2">.</span><span class="d d-3">.</span>
  </div>
</ng-template>
